import styled from 'styled-components';
// Material UI
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BMapsTooltip from 'BMapsUI/BMapsTooltip';

export default function TooltipInfo({ fontSize='smaller', ...rest }) {
    return (
        <BMapsTooltip
            tabIndex="0"
            focusable
            fontSize={fontSize}
            {...rest}
        >
            <InfoOutlinedIcon />
        </BMapsTooltip>
    );
}
